  import { CardBody } from "@material-tailwind/react";
import React, { useRef } from "react";
import { SearchBarSmallV2 } from "../form/SearchBar";
import { downloadExcel } from "react-export-table-to-excel";
import { useNavigate } from "react-router-dom";
import Select from "react-select";

export function NewDownloadExcel(props) {
  const navigate = useNavigate();
  const tableRef = useRef(null);
  const [reasonModal, setReasonModal] = React.useState(null);
  let headerNames = [];
  let dataArray = [];
  props.header.map((data) => {
    if (data.name !== "Action") headerNames.push(data.name);
  });

  props.data.data &&
    props.data.data.map((detail, id) => {
      let tempdata = [];
      props.header.map((data, idRow) => {
        if (data.name !== "Action") {
          if (data.modifiers === "Date") {
            tempdata.push(
              new Date(detail[props.header[idRow]["key"]]).toDateString()
            );
          } else {
            tempdata.push(detail[props.header[idRow]["key"]]);
          }
        }
      });
      dataArray.push(tempdata);
    });

  function handleDownloadExcel() {
    downloadExcel({
      fileName: "Report_" + props.title,
      sheet: "data",
      tablePayload: {
        header: headerNames,
        body: dataArray,
      },
    });
  }

  return (
    <div key={props.keys}>
      {!props.withoutAttribut ? (
        <div className="flex w-full justify-between px-4 pt-2 flex-col sm:flex-row mt-2">
          <div className="flex flex-row">
            {props.Master ? (
              <button
                className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white  text-gray-800 font-semibold py-2 px-4 border border-main-100 hover:bg-main-100 hover:text-white rounded shadow"
                onClick={() => props.OnClick({})}
              >
                Tambah +
              </button>
            ) : (
              <button
                onClick={handleDownloadExcel}
                className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white  text-gray-800 font-semibold py-2 px-4 border border-main-100 hover:bg-main-100 hover:text-white rounded shadow"
              >
                {" "}
                Download Excel
              </button>
            )}
          </div>
          <div className="flex flex-row w-96">
            <SearchBarSmallV2
              text={"Cari " + props.name}
              value={props.value}
              funcs={props.menuController}
            />
          </div>
        </div>
      ) : (
        <></>
      )}
      {props.data ? (
        <div className={"hidden"} style={{ maxHeight: "600px" }}>
          <table
            className="text-sm text-left text-gray-500  mt-10  w-full"
            ref={tableRef}
          >
            <thead className="text-xs text-orange-600 uppercase bg-gray-50 dark:bg-gray-700 dark:text-orange-400">
              <tr>
                {props.header.map((data, id) => {
                  if (data.name !== "Action") {
                    return (
                      <th
                        scope="col"
                        className="py-3 px-6"
                        key={"Headerpint-" + id}
                      >
                        {data.name}
                      </th>
                    );
                  }
                })}
              </tr>
            </thead>
            <tbody>
              {props.data.data &&
                props.data.data.map((detail, id) => {
                  var classOdd =
                    "bg-gray-50 border-b  hover:bg-gray-200 hover:text-main-100";
                  if (id % 2 === 0)
                    classOdd =
                      "bg-white border-b  hover:bg-gray-200 hover:text-main-100";

                  return (
                    <tr
                      className={classOdd}
                      onClick={() => {
                        if (!props.Master) {
                          props.OnClick(detail);
                        }
                      }}
                      key={"pintdata-" + id}
                    >
                      {props.header.map((data, idRow) => {
                        let texts = detail[props.header[idRow]["key"]];
                        if (props.header[idRow]["modifiers"] === "Date") {
                          texts = new Date(
                            detail[props.header[idRow]["key"]]
                          ).toLocaleDateString("ID");
                        }
                        if (texts === "Invalid Date") {
                          texts = "";
                        }
                        switch (props.header[idRow]["modifiers"]) {
                          case "Izin":
                            if (texts === "1") {
                              texts = "Pulang Cepat";
                            } else if (texts === "2") {
                              texts = "Terlambat Datang";
                            } else if (texts === "3") {
                              texts = "Keluar Jam Kerja";
                            } else if (texts === "4") {
                              texts = "Tidak masuk kerja";
                            }
                            break;
                          case "JenisTiket":
                            if (texts === "1") {
                              texts = "Darat";
                            } else if (texts === "2") {
                              texts = "Laut";
                            } else if (texts === "3") {
                              texts = "Udara";
                            }
                            break;
                          case "DasarPermohonan":
                            if (texts === "1") {
                              texts = "Cuti";
                            } else if (texts === "2") {
                              texts = "Perjalanan Dinas";
                            } else if (texts === "3") {
                              texts = "Training";
                            }
                            break;
                          case "JenisRawat":
                            if (texts === "1") {
                              texts = "Rawat Jalan";
                            } else if (texts === "2") {
                              texts = "Rawat Inap";
                            } else if (texts === "3") {
                              texts = "Operasi";
                            }
                            break;
                          case "JenisKelamin":
                            if (texts === 1) {
                              texts = "Pria";
                            } else if (texts === 0) {
                              texts = "Wanita";
                            }
                            break;
                          case "Pendidikan":
                            if (texts === "1") {
                              texts = "SD";
                            } else if (texts === "2") {
                              texts = "SMP";
                            } else if (texts === "3") {
                              texts = "SMA / SMK";
                            } else if (texts === "4") {
                              texts = "D1";
                            } else if (texts === "5") {
                              texts = "D2";
                            } else if (texts === "6") {
                              texts = "D3";
                            } else if (texts === "7") {
                              texts = "S1";
                            } else if (texts === "8") {
                              texts = "S2";
                            } else if (texts === "9") {
                              texts = "S3";
                            }
                            break;
                          case "StatusPerkawinan":
                            if (texts === "1") {
                              texts = "Belum Menikah";
                            } else if (texts === "2") {
                              texts = "Menikah";
                            }
                            break;
                          case "WargaNegara":
                            if (texts === "1") {
                              texts = "Indonesia";
                            } else if (texts === "2") {
                              texts = "Asing";
                            }
                            break;
                          case "Agama":
                            if (texts === 1) {
                              texts = "Islam";
                            } else if (texts === 2) {
                              texts = "Protestan";
                            } else if (texts === 3) {
                              texts = "Katolik";
                            } else if (texts === 4) {
                              texts = "Hindu";
                            } else if (texts === 5) {
                              texts = "Buddha";
                            } else if (texts === 6) {
                              texts = "Khonghucu";
                            }
                            break;
                          case "SistemGaji":
                            if (texts === 1) {
                              texts = "Transfer";
                            } else if (texts === 2) {
                              texts = "Cash";
                            }
                            break;
                          case "Status":
                            if (texts === "1") {
                              texts = "Aktif";
                            } else if (texts === "2") {
                              texts = "Non-Active";
                            }
                            break;
                          case "Number":
                            texts = parseFloat(texts).toLocaleString("in-ID", {
                              maximumFractionDigits: 2,
                            });
                            break;
                          case "StatusPajak":
                            switch (texts) {
                              case "1":
                                texts = "TK0";
                                break;
                              case "2":
                                texts = "TK1";
                                break;
                              case "3":
                                texts = "TK2";
                                break;
                              case "4":
                                texts = "TK3";
                                break;
                              case "5":
                                texts = "K0";
                                break;
                              case "6":
                                texts = "K1";
                                break;
                              case "7":
                                texts = "K2";
                                break;
                              case "8":
                                texts = "K3";
                                break;
                            }
                        }
                        if (props.header[idRow]["name"] !== "Action") {
                          if (props.header[idRow]["modifiers"] === "LihatPR") {
                            let LihatSelect = [
                              { label: "Purchase Requisiton", value: "1" },
                              { label: "Blanko", value: "3" },
                              // { label: "Hapus", value: "4" },
                            ];

                            return (
                              <Select
                                className={
                                  "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                                }
                                onChange={(text) => {
                                  if (text.value === "1") {
                                    navigate(
                                      "/procurment/preview/purchase-requisition/" +
                                        detail["BisnisUnitID"] +
                                        "/" +
                                        detail[
                                          "PurchaseRequisitionID"
                                        ].replaceAll("/", "-")
                                    );
                                  } else if (text.value === "4") {
                                    navigate(
                                      "/procurment/delete/purchase-requisition/" +
                                        detail["BisnisUnitID"] +
                                        "/" +
                                        detail[
                                          "PurchaseRequisitionID"
                                        ].replaceAll("/", "-")
                                    );
                                  } else if (text.value === "3") {
                                    navigate(
                                      "/procurment/blanco/purchase-requisition/" +
                                        detail["BisnisUnitID"] +
                                        "/" +
                                        detail[
                                          "PurchaseRequisitionID"
                                        ].replaceAll("/", "-")
                                    );
                                  }
                                }}
                                options={LihatSelect}
                              />
                            );
                          } else if (
                            props.header[idRow]["modifiers"] === "LihatPC"
                          ) {
                            let LihatSelect = [
                              { label: "Price Comparison", value: "1" },
                              { label: "Hapus", value: "2" },
                            ];

                            return (
                              <Select
                                className={
                                  "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                                }
                                onChange={(text) => {
                                  if (text.value === "1") {
                                    navigate(
                                      "/procurment/preview/price-comparison/" +
                                        detail["BisnisUnitID"] +
                                        "/" +
                                        detail["MPRComparisonID"].replaceAll(
                                          "/",
                                          "-"
                                        ) +
                                        "/" +
                                        detail[
                                          "PurchaseRequisitionID"
                                        ].replaceAll("/", "-")
                                    );
                                  } else if (text.value === "2") {
                                    navigate(
                                      "/procurment/delete/price-comparison/" +
                                        detail["BisnisUnitID"] +
                                        "/" +
                                        detail["MPRComparisonID"].replaceAll(
                                          "/",
                                          "-"
                                        ) +
                                        "/" +
                                        detail[
                                          "PurchaseRequisitionID"
                                        ].replaceAll("/", "-")
                                    );
                                  }
                                }}
                                options={LihatSelect}
                              />
                            );
                          } else if (
                            props.header[idRow]["modifiers"] === "LihatPO"
                          ) {
                            let LihatSelect = [
                              { label: "Purchase Requisiton", value: "1" },
                              { label: "Price Comparison", value: "2" },
                              { label: "Blanko", value: "3" },
                            ];
                            return (
                              <Select
                                className={
                                  "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                                }
                                onChange={(text) => {
                                  if (text.value === "1") {
                                    navigate(
                                      "/procurment/preview/purchase-requisition/" +
                                        detail["BisnisUnitID"] +
                                        "/" +
                                        detail[
                                          "PurchaseRequisitionID"
                                        ].replaceAll("/", "-")
                                    );
                                  } else if (text.value === "2") {
                                    navigate(
                                      "/procurment/preview/price-comparison/" +
                                        detail["BisnisUnitID"] +
                                        "/" +
                                        detail["MPRComparisonID"].replaceAll(
                                          "/",
                                          "-"
                                        ) +
                                        "/" +
                                        detail[
                                          "PurchaseRequisitionID"
                                        ].replaceAll("/", "-")
                                    );
                                  } else if (text.value === "3") {
                                    navigate(
                                      "/procurment/blanco/po/" +
                                        detail["PurchaseOrderID"]
                                    );
                                  }
                                }}
                                options={LihatSelect}
                              />
                            );
                          } else if (
                            props.header[idRow]["modifiers"] ===
                            "LihatPenerimaan"
                          ) {
                            let LihatSelect = [
                              { label: "Blanko PO", value: "1" },
                              { label: "Buat Penerimaan", value: "2" },
                            ];
                            return (
                              <Select
                                className={
                                  "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                                }
                                onChange={(text) => {
                                  if (text.value === "1") {
                                    navigate(
                                      "/procurment/blanco/po/" +
                                        detail["PurchaseOrderID"]
                                    );
                                  } else if (text.value === "2") {
                                    navigate(
                                      "/gudang/transaction/form-penerimaan-barang-add/" +
                                        detail["BisnisUnitID"] +
                                        "/" +
                                        detail["PurchaseOrderID"]
                                    );
                                  }
                                }}
                                options={LihatSelect}
                              />
                            );
                          } else if (
                            props.header[idRow]["modifiers"] ===
                            "LihatKendaraan"
                          ) {
                            let LihatSelect = [{ label: "Detail", value: "1" }];
                            return (
                              <Select
                                className={
                                  "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                                }
                                onChange={(text) => {
                                  if (text.value === "1") {
                                    navigate(
                                      "/equipment/kendaraan/preview/" +
                                        detail["TKendaraanID"]
                                    );
                                  }
                                }}
                                options={LihatSelect}
                              />
                            );
                          } else if (
                            props.header[idRow]["modifiers"] === "ApprovalPRC"
                          ) {
                            return (
                              <th
                                scope="row"
                                key={"row" + id + "-" + idRow + "-"}
                                className={"py-4 px-6 font-medium "}
                              >
                                {detail["ApprovalList"].map(
                                  (detail, id_detail) => {
                                    return (
                                      <>
                                        {detail["Status"]} - {detail["Nama"]}{" "}
                                        <br />
                                      </>
                                    );
                                  }
                                )}
                              </th>
                            );
                          } else {
                            return (
                              <th
                                scope="row"
                                key={"row" + id + "-" + idRow}
                                className={
                                  "py-4 px-6 font-medium " +
                                  (props.header[idRow]["modifiers"] ===
                                  "Number "
                                    ? "text-right"
                                    : "text-left ") +
                                  (props.header[idRow]["modifiers"] !== "Status"
                                    ? "text-black"
                                    : "text-main-100")
                                }
                              >
                                {texts}
                              </th>
                            );
                          }
                        }
                      })}
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      ) : (
        <div></div>
      )}
      <CardBody className="w-full pt-0 ">
        {props.data ? (
          <div
            className={"overflow-x-auto text-wrap relative overflow-y-auto"}
            style={{ maxHeight: "600px" }}
          >
            <table className="text-sm text-left text-gray-500  mt-10  w-full">
              <thead className="text-xs text-orange-600 uppercase bg-gray-50 dark:bg-gray-700 dark:text-orange-400">
                <tr>
                  {props.header.map((data, id) => (
                    <th scope="col" className="py-3 px-6" key={"Header-" + id}>
                      {data.name}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {props.data.data &&
                  props.data.data.map((detail, id) => {
                    var classOdd =
                      "bg-gray-50 border-b  hover:bg-gray-200 hover:text-main-100";
                    if (id % 2 === 0)
                      classOdd =
                        "bg-white border-b  hover:bg-gray-200 hover:text-main-100";

                    return (
                      <tr className={classOdd} key={"tabletr-" + id}>
                        {props.header.map((data, idRow) => {
                          let texts = detail[props.header[idRow]["key"]];
                          if (props.header[idRow]["modifiers"] === "Date") {
                            texts = new Date(
                              detail[props.header[idRow]["key"]]
                            ).toLocaleDateString("ID");
                          }
                          if (texts === "Invalid Date") {
                            texts = "";
                          }
                          switch (props.header[idRow]["modifiers"]) {
                            case "Izin":
                              if (texts === "1") {
                                texts = "Pulang Cepat";
                              } else if (texts === "2") {
                                texts = "Terlambat Datang";
                              } else if (texts === "3") {
                                texts = "Keluar Jam Kerja";
                              } else if (texts === "4") {
                                texts = "Tidak masuk kerja";
                              }
                              break;
                            case "JenisTiket":
                              if (texts === "1") {
                                texts = "Darat";
                              } else if (texts === "2") {
                                texts = "Laut";
                              } else if (texts === "3") {
                                texts = "Udara";
                              }
                              break;
                            case "DasarPermohonan":
                              if (texts === "1") {
                                texts = "Cuti";
                              } else if (texts === "2") {
                                texts = "Perjalanan Dinas";
                              } else if (texts === "3") {
                                texts = "Training";
                              }
                              break;
                            case "JenisRawat":
                              if (texts === "1") {
                                texts = "Rawat Jalan";
                              } else if (texts === "2") {
                                texts = "Rawat Inap";
                              } else if (texts === "3") {
                                texts = "Operasi";
                              }
                              break;
                            case "JenisKelamin":
                              if (texts === 1) {
                                texts = "Pria";
                              } else if (texts === 0) {
                                texts = "Wanita";
                              }
                              break;
                            case "Pendidikan":
                              if (texts === "1") {
                                texts = "SD";
                              } else if (texts === "2") {
                                texts = "SMP";
                              } else if (texts === "3") {
                                texts = "SMA / SMK";
                              } else if (texts === "4") {
                                texts = "D1";
                              } else if (texts === "5") {
                                texts = "D2";
                              } else if (texts === "6") {
                                texts = "D3";
                              } else if (texts === "7") {
                                texts = "S1";
                              } else if (texts === "8") {
                                texts = "S2";
                              } else if (texts === "9") {
                                texts = "S3";
                              }
                              break;
                            case "StatusPerkawinan":
                              if (texts === "1") {
                                texts = "Belum Menikah";
                              } else if (texts === "2") {
                                texts = "Menikah";
                              }
                              break;
                            case "WargaNegara":
                              if (texts === "1") {
                                texts = "Indonesia";
                              } else if (texts === "2") {
                                texts = "Asing";
                              }
                              break;
                            case "Agama":
                              if (texts === 1) {
                                texts = "Islam";
                              } else if (texts === 2) {
                                texts = "Protestan";
                              } else if (texts === 3) {
                                texts = "Katolik";
                              } else if (texts === 4) {
                                texts = "Hindu";
                              } else if (texts === 5) {
                                texts = "Buddha";
                              } else if (texts === 6) {
                                texts = "Khonghucu";
                              }
                              break;
                            case "SistemGaji":
                              if (texts === 1) {
                                texts = "Transfer";
                              } else if (texts === 2) {
                                texts = "Cash";
                              }
                              break;
                            case "Status":
                              if (texts === "1") {
                                texts = "Aktif";
                              } else if (texts === "2") {
                                texts = "Non-Active";
                              }
                              break;
                            case "Number":
                              texts = parseFloat(texts).toLocaleString(
                                "in-ID",
                                { maximumFractionDigits: 2 }
                              );
                              break;
                            case "StatusPajak":
                              switch (texts) {
                                case "1":
                                  texts = "TK0";
                                  break;
                                case "2":
                                  texts = "TK1";
                                  break;
                                case "3":
                                  texts = "TK2";
                                  break;
                                case "4":
                                  texts = "TK3";
                                  break;
                                case "5":
                                  texts = "K0";
                                  break;
                                case "6":
                                  texts = "K1";
                                  break;
                                case "7":
                                  texts = "K2";
                                  break;
                                case "8":
                                  texts = "K3";
                                  break;
                              }
                          }
                          if (props.header[idRow]["modifiers"] === "LihatPR") {
                            const currentUser = JSON.parse(localStorage.getItem("user"));
                            const allowedNiks = ["HO-20250504", "222"];
                            let LihatSelect = [
                              { label: "Purchase Requisiton", value: "1" },
                            ];
                            if (detail["STATUS"] === "Approved") {
                              if (!detail["IsTerima"] || !!detail["IsTerima"]) {
                                LihatSelect.push({
                                  label: "Terima",
                                  value: "5",
                                });
                              }
                              LihatSelect.push({ label: "Blanko", value: "3" });
                            }
                            if (currentUser && allowedNiks.includes(currentUser.Nik)) {
                              LihatSelect.push({ label: "Edit Attachment", value: "6" });
                            }

                            // LihatSelect.push({ label: "Hapus", value: "4" });

                            return (
                              <Select
                                className={
                                  "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                                }
                                onChange={(text) => {
                                  if (text.value === "1") {
                                    navigate(
                                      "/procurment/preview/purchase-requisition/" +
                                        detail["BisnisUnitID"] +
                                        "/" +
                                        detail[
                                          "PurchaseRequisitionID"
                                        ].replaceAll("/", "-")
                                    );
                                  } else if (text.value === "4") {
                                    navigate(
                                      "/procurment/delete/purchase-requisition/" +
                                        detail["BisnisUnitID"] +
                                        "/" +
                                        detail[
                                          "PurchaseRequisitionID"
                                        ].replaceAll("/", "-")
                                    );
                                  } else if (text.value === "3") {
                                    navigate(
                                      "/procurment/blanco/purchase-requisition/" +
                                        detail["BisnisUnitID"] +
                                        "/" +
                                        detail[
                                          "PurchaseRequisitionID"
                                        ].replaceAll("/", "-")
                                    );
                                  } else if (text.value === "5") {
                                    props.kirimTerima(
                                      detail["PurchaseRequisitionID"]
                                    );
                                  } else if (text.value === "6") {
                                    navigate(
                                      "/procurment/edit-attachment/purchase-requisition/" +
                                        detail["BisnisUnitID"] +
                                        "/" +
                                        detail[
                                          "PurchaseRequisitionID"
                                        ].replaceAll("/", "-")
                                    );
                                  }
                                }}
                                options={LihatSelect}
                              />
                            );
                          } else if (
                            props.header[idRow]["modifiers"] === "LihatPC"
                          ) {
                            const currentUserPC = JSON.parse(localStorage.getItem("user"));
                            const allowedNiksPC = ["HO-20250504", "222"];
                            let LihatSelect = [
                              { label: "Price Comparison", value: "1" },
                              { label: "Hapus", value: "2" },
                            ];
                            if (currentUserPC && allowedNiksPC.includes(currentUserPC.Nik)) {
                              LihatSelect.push({ label: "Edit Attachment", value: "6" });
                            }
                            return (
                              <Select
                                className={
                                  "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                                }
                                onChange={(text) => {
                                  if (text.value === "1") {
                                    navigate(
                                      "/procurment/preview/price-comparison/" +
                                        detail["BisnisUnitID"] +
                                        "/" +
                                        detail["MPRComparisonID"].replaceAll(
                                          "/",
                                          "-"
                                        ) +
                                        "/" +
                                        detail[
                                          "PurchaseRequisitionID"
                                        ].replaceAll("/", "-")
                                    );
                                  } else if (text.value === "2") {
                                    navigate(
                                      "/procurment/delete/price-comparison/" +
                                        detail["BisnisUnitID"] +
                                        "/" +
                                        detail["MPRComparisonID"].replaceAll(
                                          "/",
                                          "-"
                                        ) +
                                        "/" +
                                        detail[
                                          "PurchaseRequisitionID"
                                        ].replaceAll("/", "-")
                                    );
                                  } else if (text.value === "6") {
                                    navigate(
                                      "/procurment/edit-attachment/price-comparison/" +
                                        detail["BisnisUnitID"] +
                                        "/" +
                                        detail["MPRComparisonID"].replaceAll(
                                          "/",
                                          "-"
                                        ) +
                                        "/" +
                                        detail[
                                          "PurchaseRequisitionID"
                                        ].replaceAll("/", "-")
                                    );
                                  }
                                }}
                                options={LihatSelect}
                              />
                            );
                          } else if (
                            props.header[idRow]["modifiers"] ===
                            "BlankoPenerimaan"
                          ) {
                            let LihatSelect = [
                              { label: "Detail", value: "1" },
                              { label: "Edit", value: "4" },
                              { label: "Kirim", value: "3" },
                            ];
                            if (detail["Status"] === "Approved") {
                              LihatSelect = [
                                { label: "Detail", value: "1" },
                                { label: "Blanko", value: "2" },
                              ];
                            }
                            if (detail["Status"] === "Menunggu Approval") {
                              LihatSelect = [{ label: "Detail", value: "1" }];
                            }

                            return (
                              <th
                                scope="row"
                                key={"row" + id + "-" + idRow}
                                className={
                                  "py-4 px-6 font-medium whitespace-nowrap " +
                                  (props.header[idRow]["modifiers"] ===
                                  "Number "
                                    ? "text-right"
                                    : "text-left ") +
                                  (props.header[idRow]["modifiers"] !== "Status"
                                    ? "text-black"
                                    : "text-main-100")
                                }
                              >
                                <Select
                                  className={
                                    "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                                  }
                                  onChange={(text) => {
                                    if (text.value === "1") {
                                      navigate(
                                        "/gudang/transaction/detail-penerimaan-barang/" +
                                          props.CustomBisnisUnit +
                                          "/" +
                                          detail[
                                            "GoodsAcceptanceID"
                                          ].replaceAll("/", "-")
                                      );
                                    } else if (text.value === "2") {
                                      navigate(
                                        "/gudang/blanco/" +
                                          detail[
                                            "GoodsAcceptanceID"
                                          ].replaceAll("/", "-")
                                      );
                                    } else if (text.value === "3") {
                                      props.kirim(
                                        detail["GoodsAcceptanceID"].replaceAll(
                                          "/",
                                          "-"
                                        )
                                      );
                                    } else if (text.value === "4") {
                                      navigate(
                                        "/gudang/transaction/form-penerimaan-barang/" +
                                          props.CustomBisnisUnit +
                                          "/" +
                                          detail[
                                            "GoodsAcceptanceID"
                                          ].replaceAll("/", "-")
                                      );
                                    }
                                  }}
                                  options={LihatSelect}
                                />
                              </th>
                            );
                          } else if (
                            props.header[idRow]["modifiers"] === "LihatPO"
                          ) {
                            let LihatSelect = [
                              { label: "Purchase Requisiton", value: "1" },
                              { label: "Price Comparison", value: "2" },
                              { label: "Blanko", value: "3" },
                            ];
                            return (
                              <Select
                                className={
                                  "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                                }
                                onChange={(text) => {
                                  if (text.value === "1") {
                                    navigate(
                                      "/procurment/preview/purchase-requisition/" +
                                        detail["BisnisUnitID"] +
                                        "/" +
                                        detail[
                                          "PurchaseRequisitionID"
                                        ].replaceAll("/", "-")
                                    );
                                  } else if (text.value === "2") {
                                    navigate(
                                      "/procurment/preview/price-comparison/" +
                                        detail["BisnisUnitID"] +
                                        "/" +
                                        detail["MPRComparisonID"].replaceAll(
                                          "/",
                                          "-"
                                        ) +
                                        "/" +
                                        detail[
                                          "PurchaseRequisitionID"
                                        ].replaceAll("/", "-")
                                    );
                                  } else if (text.value === "3") {
                                    navigate(
                                      "/procurment/blanco/po/" +
                                        detail["PurchaseOrderID"]
                                    );
                                  }
                                }}
                                options={LihatSelect}
                              />
                            );
                          } else if (
                            props.header[idRow]["modifiers"] ===
                            "LihatPenerimaan"
                          ) {
                            let LihatSelect = [
                              { label: "Blanko PO", value: "1" },
                              { label: "Buat Penerimaan", value: "2" },
                            ];
                            return (
                              <Select
                                className={
                                  "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                                }
                                onChange={(text) => {
                                  if (text.value === "1") {
                                    navigate(
                                      "/procurment/blanco/po/" +
                                        detail["PurchaseOrderID"]
                                    );
                                  } else if (text.value === "2") {
                                    navigate(
                                      "/gudang/transaction/form-penerimaan-barang-add/" +
                                        detail["BisnisUnitID"] +
                                        "/" +
                                        detail["PurchaseOrderID"]
                                    );
                                  }
                                }}
                                options={LihatSelect}
                              />
                            );
                          } else if (
                            props.header[idRow]["modifiers"] ===
                            "LihatKendaraan"
                          ) {
                            let LihatSelect = [{ label: "Detail", value: "1" }];
                            return (
                              <Select
                                className={
                                  "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                                }
                                onChange={(text) => {
                                  if (text.value === "1") {
                                    navigate(
                                      "/equipment/kendaraan/preview/" +
                                        detail["TKendaraanID"]
                                    );
                                  }
                                }}
                                options={LihatSelect}
                              />
                            );
                          } else if (
                            props.header[idRow]["modifiers"] === "ApprovalPRC"
                          ) {
                            return (
                              <th
                                scope="row"
                                key={"row" + id + "-" + idRow + "-"}
                                className={"py-4 px-6 text-xs font-medium w-20"}
                              >
                                {detail["ApprovalList"].map((item, id_detail) => {
                                  const isReject = (item["Status"] || "").includes(
                                    "Ditolak"
                                  );
                                  return (
                                    <React.Fragment key={id_detail}>
                                      <span
                                        onClick={
                                          isReject
                                            ? () =>
                                                setReasonModal({
                                                  nama: item["Nama"],
                                                  keterangan:
                                                    item["KeteranganTolak"],
                                                })
                                            : undefined
                                        }
                                        title={
                                          isReject
                                            ? "Klik untuk lihat alasan penolakan"
                                            : undefined
                                        }
                                        className={
                                          "flex-wrap w-full" +
                                          (isReject
                                            ? " text-red-600 font-semibold underline cursor-pointer hover:text-red-800"
                                            : "")
                                        }
                                      >
                                        {item["Status"] + " - " + item["Nama"]}
                                      </span>
                                      <br />
                                      <br />
                                    </React.Fragment>
                                  );
                                })}
                              </th>
                            );
                          } else {
                            return (
                              <th
                                scope="row"
                                key={"row" + id + "-" + idRow}
                                className={
                                  "py-4 px-6 font-medium " +
                                  (props.header[idRow]["modifiers"] ===
                                  "Number "
                                    ? "text-right"
                                    : "text-left ") +
                                  (props.header[idRow]["modifiers"] !== "Status"
                                    ? "text-black"
                                    : "text-main-100")
                                }
                              >
                                {texts}
                              </th>
                            );
                          }
                        })}
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        ) : (
          <div />
        )}
      </CardBody>

      {reasonModal ? (
        <div
          className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-40 px-4"
          onClick={() => setReasonModal(null)}
        >
          <div
            className="w-full max-w-md rounded-lg bg-white shadow-xl"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between border-b px-5 py-3">
              <h3 className="text-sm font-bold text-red-600">
                Alasan Penolakan
              </h3>
              <button
                type="button"
                onClick={() => setReasonModal(null)}
                className="text-gray-400 hover:text-gray-700 text-xl leading-none"
              >
                &times;
              </button>
            </div>
            <div className="px-5 py-4">
              <p className="mb-2 text-xs uppercase tracking-wide text-gray-500">
                Ditolak oleh
              </p>
              <p className="mb-4 text-sm font-semibold text-gray-800">
                {reasonModal.nama || "-"}
              </p>
              <p className="mb-2 text-xs uppercase tracking-wide text-gray-500">
                Keterangan
              </p>
              <p className="whitespace-pre-wrap text-sm text-gray-800">
                {reasonModal.keterangan && reasonModal.keterangan.trim() !== ""
                  ? reasonModal.keterangan
                  : "Tidak ada keterangan penolakan yang dicatat."}
              </p>
            </div>
            <div className="flex justify-end border-t px-5 py-3">
              <button
                type="button"
                onClick={() => setReasonModal(null)}
                className="rounded-lg bg-main-100 px-4 py-2 text-sm font-medium text-white hover:opacity-90"
              >
                Tutup
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}
